import { Box, Stack } from "@mui/material";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";

function ListHelperText(props: { children: React.ReactNode }) {
  const { children } = props;
  return <Text variant="body2">{children}</Text>;
}

function ListHelperItem(props: { children: React.ReactNode }) {
  const { children } = props;
  return (
    <Stack direction="row" spacing={1}>
      <Box>
        <CbhIcon type="dot" size="xSmall" />
      </Box>
      {children}
    </Stack>
  );
}

export function ListHelper(props: { children: React.ReactNode }) {
  const { children } = props;
  return <Stack spacing={3}>{children}</Stack>;
}

ListHelper.Item = ListHelperItem;
ListHelper.Text = ListHelperText;
